import { render, staticRenderFns } from "./schedule_day.vue?vue&type=template&id=502fc80d&"
import script from "./schedule_day.vue?vue&type=script&lang=js&"
export * from "./schedule_day.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports